module.exports = __webpack_public_path__ + "static-portal/img/news12-5.93cbf95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news12-5.jpg
// module id = 7j7H
// module chunks = 4